import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const SearchBoxContainer = styled.div`
    display: 'flex';
    justify-content: space-between;
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    color: #140f4b;
    margin: ${(props) =>
                props.marginDesktop ? props.marginDesktop : '15px 15px'};
    background: ${({ background }) =>
        background ? background : '#ffffff 0% 0% no-repeat padding-box'};

    align-items: center;
    ${media.mobileDevice`                   
            margin: ${(props) =>
                props.margin ? props.margin : 'auto 15px 0px 15px'};
            display:flex;
            width: ${(props) =>
                props.containerMobileWidth
                    ? props.containerMobileWidth
                    : '100%'};
    `}
`;

export const StyledI = styled.i.attrs(() => ({
    className: 'pi pi-search',
}))`
    /* ${media.mobileDevice`       

  ::before {
  float: right;
  padding-right: 10px;
  }
      
  `} */
`;
